import React from 'react'
import { useDispatch } from 'react-redux'
import { Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { startTour } from '../../reducers/tour/actions'

const PageTourButton = ({ steps }) => {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(
      startTour({
        tourSteps: steps,
        tourChangeSteps: () => {},
        tourCompleted: () => {},
      }),
    )
  }

  return (
    <Tooltip title="Take a tour of this page">
      <QuestionCircleOutlined
        onClick={handleClick}
        style={{
          fontSize: 16,
          color: '#bbb',
          cursor: 'pointer',
          marginLeft: 8,
          transition: 'color 0.2s',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = '#4caf50')}
        onMouseLeave={(e) => (e.currentTarget.style.color = '#bbb')}
      />
    </Tooltip>
  )
}

export default PageTourButton
